(function() {
  'use strict';
  const details = Array.from(document.querySelectorAll('details'));

  // Add onclick listeners
  details.forEach(targetDetail => {
    let clickables = targetDetail.querySelectorAll('a');
    clickables.forEach((item) => {
      item.addEventListener('click', function(evt){
        // stop events bubbling through and triggering meetids
        evt.stopPropagation();
      })
    })
  });
})();
